import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ElementorPage from "../../ElementorPage";

export default function LocationPage({ locationPagesURLs }: { locationPagesURLs: Record<string, number> }) {
    const location = useLocation();
    const cleanPath = location.pathname.replace(/^\/locations/, "").toLowerCase();
    const matchedKey = Object.keys(locationPagesURLs).find((key) => cleanPath.includes(key));
    const pageId = matchedKey ? locationPagesURLs[matchedKey] : undefined;

    useEffect(() => {
        if (!pageId) return;

        const addCssLink = (cssUrl: string) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = cssUrl;
            document.head.appendChild(link);
            return link;
        };

        const removeCssLink = (link: Element | null) => {
            if (link && link.parentNode) {
                link.parentNode.removeChild(link);
            }
        };

        if (cleanPath && location.pathname.includes(cleanPath)) {
            let cssUrl;
            cssUrl = `${process.env.REACT_APP_BLOG_URL}/wp-content/uploads/elementor/css/post-${pageId}.css`;
            
            const cssUrlWithCacheBust = `${cssUrl}?v=${new Date().getTime()}`;
            const link = addCssLink(cssUrlWithCacheBust);

            return () => {
                removeCssLink(link);
            };
        } else {
            let link;
            link = document.querySelector(`link[href*="post-${pageId}.css"]`);
            removeCssLink(link);
        }

    }, [cleanPath, location.pathname, pageId]);

    if (!pageId) return <h1>Page Not Found</h1>;

    return (
        <ElementorPage pageNo={pageId} />
    )
}
